const metadataAttributes = {
  // Meta tags
  metaDataDescription: "string",
  metaDataKeywords: "stringlist",
  robotsIndex: ["enum", { values: ["yes", "no"] }],
  // Twitter legacy attributes (kept for backwards compatibility)
  tcCreator: "string",
  tcDescription: "string",
  tcImage: ["reference", { only: ["Image"] }],
  tcTitle: "string",
  // Open Graph attributes
  ogDescription: "string",
  ogImage: ["reference", { only: ["Image"] }],
  ogImageAlt: "string",
  ogLocale: "string",
  ogSection: "string",
  ogSiteName: "string",
  ogTitle: "string",
};

export default metadataAttributes;
